{
    "NAME": "AdministratorübersichtSprache",
    "AdminOverview_Intro": "Wählen Sie einen CME, einen Telefonieserver und eine Partition aus, um die verfügbaren Administrationsbereiche und die aktuellen Zählerstände anzuzeigen.",
    "AdminOverview_Search_Helper": "Die Suche bezieht sich auf die hier angezeigten Zählergebnisse und wird auf die ausgewählte Admin-Seite übertragen.",
    "AdminOverview_State_Loading": "Laden",
    "AdminOverview_State_Error": "Die neuesten Zählerstände konnten nicht geladen werden.",
    "AdminOverview_State_NoTelephonyServer": "Kein Telefonserver im Geltungsbereich",
    "AdminOverview_State_SelectTelephonyServer": "Wählen Sie einen Telefonieserver aus, um diese Zählung zu laden.",
    "AdminOverview_State_SelectTelephonyServerAndPartition": "Wählen Sie einen Telefonieserver und eine Partition aus, um diese Zählung zu laden.",
    "AdminOverview_State_SelectPartition": "Wählen Sie eine bestimmte Partition aus, um diese Anzahl anzuzeigen.",
    "AdminOverview_State_MessagesLegacy": "Legacy-Administrationsseite",
    "AdminOverview_State_DatabaseLegacy": "Legacy-Administrationsseite",
    "AdminOverview_Tile_Cme_Title": "CMEs",
    "AdminOverview_Tile_Cme_Subtitle": "Servicestruktur",
    "AdminOverview_Tile_Cme_Summary": "Kinder CMEs",
    "AdminOverview_Tile_Cme_Aria": "Offene CMEs",
    "AdminOverview_Tile_Telsys_Title": "Telefonieserver",
    "AdminOverview_Tile_Telsys_Subtitle": "Plattform-Immobilien",
    "AdminOverview_Tile_Telsys_Summary": "Gesamtzahl der Server",
    "AdminOverview_Tile_Telsys_Aria": "Offene Telefonieserver",
    "AdminOverview_Tile_Partitions_Title": "Partitionen",
    "AdminOverview_Tile_Partitions_Subtitle": "Partitionierungsbereich",
    "AdminOverview_Tile_Partitions_Summary": "Partitionen",
    "AdminOverview_Tile_Partitions_Aria": "Offene Partitionen",
    "AdminOverview_Tile_Users_Title": "Benutzer",
    "AdminOverview_Tile_Users_Subtitle": "Anwendungszugriff",
    "AdminOverview_Tile_Users_Summary": "Benutzer",
    "AdminOverview_Tile_Users_Aria": "Offene Benutzer",
    "AdminOverview_Tile_Devices_Title": "Geräte",
    "AdminOverview_Tile_Devices_Subtitle": "Endpunktinventar",
    "AdminOverview_Tile_Devices_Summary": "Geräte",
    "AdminOverview_Tile_Devices_Aria": "Offene Geräte",
    "AdminOverview_Tile_Devices_Extension": "Verlängerung",
    "AdminOverview_Tile_Devices_ExtensionTrunking": "Erweiterung (Trunking)",
    "AdminOverview_Tile_Devices_ExtensionHospitality": "Erweiterung (Gastgewerbe)",
    "AdminOverview_Tile_Devices_Groups": "Gruppen",
    "AdminOverview_Tile_Devices_AutoAttendant": "Automatischer Anrufbeantworter",
    "AdminOverview_Tile_Agents_Title": "Agenten",
    "AdminOverview_Tile_Agents_Subtitle": "Warteschlangenoperationen",
    "AdminOverview_Tile_Agents_Summary": "Agenten",
    "AdminOverview_Tile_Agents_Aria": "Offene Agenten",
    "AdminOverview_Tile_Directory_Title": "Verzeichnis",
    "AdminOverview_Tile_Directory_Subtitle": "Kontaktdatensätze",
    "AdminOverview_Tile_Directory_Summary": "Verzeichnisse",
    "AdminOverview_Tile_Directory_Aria": "Verzeichnis öffnen",
    "AdminOverview_Tile_Codes_Title": "Codes",
    "AdminOverview_Tile_Codes_Subtitle": "Codeverwaltung",
    "AdminOverview_Tile_Codes_Summary": "Codes",
    "AdminOverview_Tile_Codes_Aria": "Offene Codes",
    "AdminOverview_Tile_Recording_Title": "Aufnahme",
    "AdminOverview_Tile_Recording_Subtitle": "Integrationen",
    "AdminOverview_Tile_Recording_Summary": "Aufnahmen",
    "AdminOverview_Tile_Recording_Aria": "Öffentliche Aufzeichnung",
    "AdminOverview_Tile_Messages_Title": "Nachrichten",
    "AdminOverview_Tile_Messages_Subtitle": "Legacy-Tools",
    "AdminOverview_Tile_Messages_Aria": "Nachrichten öffnen",
    "AdminOverview_Tile_Database_Title": "Datenbank",
    "AdminOverview_Tile_Database_Subtitle": "Legacy-Tools",
    "AdminOverview_Tile_Database_Aria": "Datenbank öffnen"
}